import { createContext, type ReactNode } from 'react';

import useMediaLibrarySearchQuery from '~modules/media-library/context/useMediaLibrarySearchQuery';
import useMediaLibrarySettings from '~modules/media-library/context/useMediaLibrarySettings';
import useSearch from '~modules/media-library/controller/useSearch';
import { type AssetId } from '~modules/media-library/model/Asset';

export const MediaLibrarySearchResultContext = createContext<
  | {
      // values
      resultAssetIds: AssetId[];
      resultCount: number;
      isLoading: boolean;
      isError: boolean;
      // handlers
      onLoadMore: () => void;
      resetSearchResult: () => void;
    }
  | undefined
>(undefined);

export function MediaLibrarySearchResultProvider({ children }: { children: ReactNode }) {
  const { realm, idCollection } = useMediaLibrarySettings();
  const { searchQuery } = useMediaLibrarySearchQuery();

  const value = useSearch(realm, searchQuery, idCollection);

  return <MediaLibrarySearchResultContext.Provider value={value}>{children}</MediaLibrarySearchResultContext.Provider>;
}
